export default "__VITE_ASSET__Dk2oXmw$__"